<template>
  <div class="catalog">
    <van-cell center v-for="(item,index) in list" :key="index" is-link :to="item.url">
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <svg class="icon" aria-hidden="true">
          <use :xlink:href="'#icon-' + item.icon"></use>
        </svg>
        <span class="name">{{item.name}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
import {defineComponent, ref} from 'vue';

export default defineComponent({
  name: "Catalog",
	setup(){
      const list = ref([
          {
              icon: 'malie',
              name: '马克思主义、列宁主义、毛泽东思想、邓小平理论',
              url: '/catalogList/A',
          }, {
              icon: 'zhexue-zongjiao',
              name: '哲学、宗教',
              url: '/catalogList/B',
          }, {
              icon: 'shehuikexue',
              name: '社会科学总论',
              url: '/catalogList/C',
          }, {
              icon: 'zhengzhi-falv',
              name: '政治、法律',
              url: '/catalogList/D',
          }, {
              icon: 'junshi',
              name: '军事',
              url: '/catalogList/E',
          }, {
              icon: 'jingji',
              name: '经济',
              url: '/catalogList/F',
          }, {
              icon: 'wenhua',
              name: '文化、科学、教育、体育',
              url: '/catalogList/G',
          }, {
              icon: 'yuyan-wenzi',
              name: '语言、文字',
              url: '/catalogList/H',
          }, {
              icon: 'wenxue',
              name: '文学',
              url: '/catalogList/I',
          }, {
              icon: 'yishu',
              name: '艺术',
              url: '/catalogList/J',
          }, {
              icon: 'lishi-dili',
              name: '历史、地理',
              url: '/catalogList/K',
          }, {
              icon: 'zirankexue',
              name: '自然科学总论',
              url: '/catalogList/N',
          }, {
              icon: 'shuli-huaxue',
              name: '数理科学和化学',
              url: '/catalogList/O',
          }, {
              icon: 'tianwen-diqiu',
              name: '天文学、地球科学',
              url: '/catalogList/P',
          }, {
              icon: 'shengwu',
              name: '生物科学',
              url: '/catalogList/Q',
          }, {
              icon: 'yiyao-weisheng',
              name: '医药、卫生',
              url: '/catalogList/R',
          }, {
              icon: 'nongye',
              name: '农业科学',
              url: '/catalogList/S',
          }, {
              icon: 'gongyejishu',
              name: '工业技术',
              url: '/catalogList/T',
          }, {
              icon: 'jiaotong-yunshu',
              name: '交通运输',
              url: '/catalogList/U',
          }, {
              icon: 'hangkong-hangtian',
              name: '航空、航天',
              url: '/catalogList/V',
          }, {
              icon: 'huanjing-anquan',
              name: '环境科学、安全科学',
              url: '/catalogList/X',
          }, {
              icon: 'zonghe',
              name: '综合性图书',
              url: '/catalogList/Z',
          }
      ]);
      return{
          list
      }
	}
});
</script>

<style scoped lang="less">
@import "../assets/css/catalog.less";
</style>
